const PERFORMANCE_REPORT = 'Performance Report'

export const NOTEBOOK_TITLES = ['Grid View', PERFORMANCE_REPORT]

export const NOTEBOOK_PARAMETER_NAMES = {
  source_type: 'investment_object_type',
  investment_item: 'investment_item',
  data_set: 'data_set',
  performance_report: 'performance_report',
  delivery_destination: 'delivery_destination',
}

export const PARAMETER_NAMES = [
  'investment_item',
  'data_set',
  'performance_report',
  'delivery_destination',
]

export const DELIVERY_DESTINATION = 'delivery_destination'

export const DELIVERY_TYPES = {
  emails: 'Email',
  ftps: 'FTP',
  emailField: 'emailField',
  destinationsField: 'destinationsField',
}

export const SOURCE_TYPES = {
  list: 'investment_list',
  searchcriteria: 'search_criteria',
  performancereport: 'performance_report',
}

export const FIXED_PARAMETERS = [
  'job_name',
  'investment_object_type',
  'delivery_type',
  'delivery_destination',
  'investment_item',
]

export const COMPONENT_STEPS = {
  0: 'SourceStep',
  1: 'ParametersStep',
  2: 'FormatStep',
  3: 'DeliveryStep',
}

export const MODAL_LOADED_MESSAGE = {
  type: 4,
  retval: 1,
  data: { origin: 'DirectFeedManager', action: 'ModalLoaded' },
}

export const FEED_ACTION_MESSAGE = {
  type: 4,
  retval: 1,
  data: { origin: 'DirectFeedManager', action: 'isFeedCreatedOrUpdated' },
}

export const CLOSE_MESSAGE = {
  type: 4,
  retval: 1,
  data: { origin: 'DirectFeedManager', action: 'CloseWindow' },
}

export const SUCCESS_MODAL_MESSAGE = {
  type: 4,
  retval: 1,
  data: { origin: 'DirectFeedManager', action: 'SuccessCloseWindow' },
}

export const CANCEL_MESSAGE = {
  type: 4,
  retval: 2,
  data: { origin: 'DirectFeedManager', action: 'CloseWindow' },
}

export const generateFeedDetailsMessage = (action, feed) => ({
  type: 4,
  retval: 2,
  data: { origin: 'DirectFeedManager', action, feed },
})
